import clsx from 'clsx';

const cn = clsx;

export default cn;
